export const isValidImageReference = (value: unknown): boolean => {
  if (typeof value !== "string") return false;

  const v = value.trim();
  if (v.length === 0) return false;

  // base64 images
  if (v.startsWith("data:image/")) return true;

  // blob references
  if (v.startsWith("blob:")) return true;

  // imgix URLs
  if (v.includes("imgix.net")) return true;

  // classic image extensions
  const imageExtPattern = /\.(png|jpe?g|webp|gif|bmp|svg)$/i;
  if (imageExtPattern.test(v)) return true;

  return false;
};
